<template>
  <div class="goods_all">
    <div :class="[isCollapse ? 'open_cop' : 'close_cop']">
      <statusBar ref="goods_left" :isTreeBar="'goods'" :page_goods_data="page_goods_data" :dataList="status_data"
        @getGoods="goods_list" @width_change="get_width($event)"></statusBar>
    </div>
    <!-- 右侧内容 -->
    <div class="right_content">
      <div class="goods_head">
        <div>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="toAddGoods">添加商品</el-button>
          <el-button type="primary" v-if="page_goods_data.flag == 1" size="small" icon="el-icon-sort"
            @click="line_click(0)">下架</el-button>
          <el-button type="primary" v-if="page_goods_data.flag == 2" size="small" icon="el-icon-sort"
            @click="line_click(1)">上架</el-button>
          <el-button type="primary" v-if="page_goods_data.flag == 3" size="small" icon="el-icon-upload"
            @click="get_audit">提审</el-button>
          <el-button type="primary" v-if="page_goods_data.flag == 4" size="small" icon="el-icon-refresh-right"
            @click="origin_click">还原</el-button>
          <el-button type="primary" v-if="page_goods_data.flag != 1" size="small" icon="el-icon-delete"
            @click="delete_click">删除</el-button>
        </div>
        <div style="display: flex">
          <div class="elinputbox">
            <el-select clearable v-model="category_value" placeholder="请选择">
              <el-option value="deptName" style="height: auto; background: #ffffff">
                <el-tree :data="options" accordion :props="defaultProps" @node-click="handleNodeClick"></el-tree>
              </el-option>
            </el-select>
          </div>
          <el-input v-model="page_goods_data.keyword" style="padding: 0 10px; width: 190px"
            placeholder="名称/商品编码/SKU编码"></el-input>
          <el-button type="primary" size="small" icon="el-icon-search" @click="search_btn">搜索</el-button>
        </div>
      </div>
      <div style="width: 99%" class="goods_table">
        <el-table v-loading="page_goods_data.isLoading" ref="multipleTable" :data="goodsData.records"
          tooltip-effect="dark" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column label="商品" align="center">
            <template slot-scope="scope">
              <div class="goods_name_box">
                <div>
                  <el-image :z-index="99999" style="width: 80px; height: 80px"
                    :src="scope.row.images ? src_list(scope.row.images, 1) : ''" :preview-src-list="scope.row.images ? src_list(scope.row.images, 2) : []
                      ">
                  </el-image>
                </div>
                <div class="goods_text_box">
                  <div class="name_box">{{ scope.row.title }}</div>
                  <div class="name_box">{{ scope.row.subTitle }}</div>
                  <div class="categ_box">[{{ scope.row.categoryAllName }}]</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="goodsCode" width="170" label="商品编码" align="center">
          </el-table-column>
          <el-table-column label="价格" width="200" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <div>
                {{
                  "¥" +
                  $api.returnFloat(scope.row.lowPrice) +
                  "-" +
                  "¥" +
                  $api.returnFloat(scope.row.maxPrice)
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="120" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.audit == -1">
                <el-popover placement="top-start" title="审核不通过" width="200" trigger="hover"
                  :content="scope.row.auditRemark">
                  <div slot="reference" style="background:#f56c6c" class="stuts_box">{{ return_stuts(scope.row) }}</div>
                </el-popover>
              </div>
              <div v-else>
                <!-- <el-popover v-if="scope.row.online == 1" placement="top" width="160" v-model="offPromipt">
                  <p>确定要下架该商品吗？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="offPromipt = false">取消</el-button>
                    <el-button type="primary" size="mini" @click="confirmPropmipt(scope.row)">确定</el-button>
                  </div>
                  <el-button type="primary" size="mini" slot="reference">{{ return_stuts(scope.row) }}</el-button>
                </el-popover> -->
                <div  :class="[scope.row.audit == 0 ? 'wait_box' : 'stuts_box']">{{ return_stuts(scope.row) }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建/更新时间" width="270" align="center">
            <template slot-scope="scope">
              <div>
                {{
                  $api
                    .moment(scope.row.createTime)
                    .format("YYYY-MM-DD HH:mm:ss")
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <div style="cursor: pointer; font-size: 20px">
                <i class="el-icon-edit-outline" @click="edit_box(scope.row)"></i>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="block">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="page_goods_data.pageNo" :page-size="page_goods_data.pageSize"
          layout="total, prev, pager, next" :total="goodsData.total" :hide-on-single-page="show_page">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import statusBar from "../../components/statusBar";
let _this;
import {
  get_category,
  online_goods,
  delete_goods_recycle,
  delete_goods,
  goods_origin,
  audit_goods,
} from "@/request/api/goods";
export default {
  components: {
    statusBar,
  },
  data() {
    return {
      offPromipt: false,
      category_value: "",
      defaultProps: {
        children: "children",
        label: "label",
      },
      page_goods_data: {
        pageNo: 1,
        pageSize: 10,
        flag: 1, //出售中：1仓库中：2待审核：3回收站：4
        baseCategoryId: "", //分类id
        keyword: "", //搜索关键字
        isLoading: false, //加载
      },
      isCollapse: true,
      status_data: [
        { name: "出售中", type: 1 },
        { name: "仓库中", type: 2 },
        { name: "待审核", type: 3 },
        { name: "回收站", type: 4 },
      ],
      currentPage1: 5,
      show_page: true, //判断隐藏分页
      input: "",
      goodsData: {},
      options: [],
      select_list: [],
      nav_path: [
        {
          name: "首页",
          path: "/home",
        },
        {
          name: "商品",
          // path:'/goods'
        },
      ],
    };
  },
  watch: {
    "page_goods_data.flag"() {
      this.select_list = [];
    },
  },
  created() {
    _this = this;
    get_category().then((res) => {
      console.log(res.data);
      this.options = res.data;
    });
  },
  methods: {
    confirmPropmipt(e) {
      console.log(e)
      this.select_list = [e.id]
      this.line_click(0)
      this.offPromipt = false
    },
    get_audit() {
      audit_goods({ goodsIds: _this.select_list }).then(res => {
        if (res.code == 0) {
          this.$api.s_msg(res.msg)
          this.$refs.goods_left.get_goods_list(this.page_goods_data)
        } else {
          this.$api.e_msg(res.msg)
        }
        console.log(res)
      })
    },
    // audit  0待提交  1待审核   2审核通过   -1审核不通过
    // online  1上架   0下架
    return_stuts(data) {
      if (data.online == 1) {
        return '销售中'
      } else {
        if (data.audit == 0) {
          return '待提交'
        } else if (data.audit == 1) {
          return '待审核'
        } else if (data.audit == 2) {
          return '审核通过'
        } else if (data.audit == -1) {
          return '审核不通过'
        }
      }
    },
    edit_box(e) {
      console.log(e);
      this.$router.push({
        name: 'goodsBox',
        params: {
          id: e.id,
        },
      });
    },
    toAddGoods() {
      this.$router.push({
        name: 'goodsBox',
        params: {
          id: 0,
        },
      });
    },
    origin_click() {
      goods_origin({ goodsIds: _this.select_list }).then((res) => {
        console.log(res);
        _this.request_after(res);
      });
    },
    delete_click() {
      if (this.page_goods_data.flag == 4) {
        this.$confirm("将永久删除商品,确认吗？")
          .then(() => {
            delete_goods({ goodsIds: _this.select_list }).then((res) => {
              console.log(res);
              _this.request_after(res);
            });
          })
          .catch(() => { });
      } else {
        this.$confirm("确认删除？")
          .then(() => {
            delete_goods_recycle({ goodsIds: _this.select_list }).then(
              (res) => {
                _this.request_after(res);
              }
            );
          })
          .catch(() => { });
      }

      console.log(this.select_list);
    },
    // 上下架
    line_click(e) {
      if (e) {
        //上架
        online_goods({
          goodsIds: this.select_list,
          online: 1,
        }).then((res) => {
          _this.request_after(res);
        });
      } else {
        online_goods({
          goodsIds: this.select_list,
          online: 0,
        }).then((res) => {
          _this.request_after(res);
        });
      }
    },
    search_btn() {
      console.log(this.page_goods_data);
      this.$refs.goods_left.get_goods_list(this.page_goods_data);
    },
    handleNodeClick(data) {
      console.log(data);
      this.category_value = data.rankName;
      this.page_goods_data.baseCategoryId = data.id;
    },
    //   图片预览
    src_list(e, type) {
      if (type == 1) {
        return e.split(",")[0];
      } else {
        return e.split(",");
      }
      // console.log(e.split(","))
      // return e.split(",");
    },
    goods_list(e) {
      this.goodsData = e;
      console.log(e);
    },
    get_width(e) {
      this.isCollapse = e;
      console.log(e);
      this.$forceUpdate();
    },
    handleSizeChange() {
      console.log(999);
    },
    handleCurrentChange() {
      console.log(222);
    },
    handleSelectionChange(val) {
      this.select_list = [];
      if (val.length != 0) {
        val.forEach((item) => {
          this.select_list.push(item.id);
        });
      }
    },
    // 封装请求后回调
    request_after(res) {
      if (res.code == 0) {
        this.$refs.goods_left.get_goods_list(this.page_goods_data);
        this.$api.s_msg(res.msg);
      } else {
        this.$api.e_msg(res.msg);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/ .el-input__icon {
  line-height: 32px;
}

.elinputbox /deep/ .el-input {
  width: 170px;
}

.stuts_box {
  border-radius: 5px;
  background: #409EFF;
  color: #ffffff;
  padding: 1px 5px;
  display: inline-block;
  cursor: pointer;
}

.wait_box {
  background-color: #67c23a;
  color: #ffffff;
  padding: 1px 5px;
  display: inline-block;
  cursor: pointer;
  border-radius: 5px;
}

.close_cop {
  text-align: center;
  border-right: 1px solid #eeeeee;
  -webkit-animation: goods_close 1s ease forwards;
  -o-animation: goods_close 1s ease forwards;
  -moz-animation: goods_close 1s ease forwards;
  animation: goods_close 1s ease forwards;
}

.open_cop {
  border-right: 1px solid #eeeeee;
  -webkit-animation: goods_open 1s ease forwards;
  -o-animation: goods_open 1s ease forwards;
  -moz-animation: goods_open 1s ease forwards;
  animation: goods_open 1s ease forwards;
}

@keyframes goods_close {
  from {
    width: 8%;
  }

  to {
    width: 2%;
  }
}

@keyframes goods_open {
  from {
    width: 2%;
  }

  to {
    width: 8%;
  }
}

.goods_all {
  background: #ffffff;
  border-top: 1px solid #eeeeee;
  // height: calc(100% - 42px);
  height: 100%;
  // display: block;
  width: 100%;
  display: flex;

  .right_content {
    width: 100%;
    height: 100%;
    // padding: 40px 20px 10px 40px;
    box-sizing: border-box;

    .goods_head {
      width: 100%;
      height: 10%;
      border-bottom: 1px solid #ebeef5;
      padding: 0 20px;
      align-items: center;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
    }

    .goods_table {
      height: 80%;
      overflow: hidden;
      overflow-y: auto;

      .goods_name_box {
        display: flex;
        justify-content: flex-start;

        .goods_text_box {
          flex: 1;
          display: flex;
          flex-direction: column;
          text-align: left;
          // justify-content: space-between;
          margin-left: 10px;

          .name_box {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
          }

          .categ_box {
            color: #409eff;
            padding-top: 10px;
          }
        }
      }
    }

    .block {
      height: 9%;
      display: flex;
      justify-content: center;
      align-items: center;

    }
  }
}
</style>